/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_Toast_SuccessInputs */

const en_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format completed`)
};

const fr_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme automatique terminee`)
};

const de_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung abgeschlossen`)
};

const it_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione automatica completata`)
};

const ru_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование завершено`)
};

const es_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático completado`)
};

const zh_cn2_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化完成`)
};

const ja_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマットが完了しました`)
};

const hi_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट पूरा हुआ`)
};

const pt_pt2_auto_format_toast_success = /** @type {(inputs: Auto_Format_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática concluída`)
};

/**
* | output |
* | --- |
* | "Auto format completed" |
*
* @param {Auto_Format_Toast_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_toast_success = /** @type {((inputs?: Auto_Format_Toast_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_Toast_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_toast_success(inputs)
	if (locale === "de") return de_auto_format_toast_success(inputs)
	if (locale === "it") return it_auto_format_toast_success(inputs)
	if (locale === "ru") return ru_auto_format_toast_success(inputs)
	if (locale === "es") return es_auto_format_toast_success(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_toast_success(inputs)
	if (locale === "ja") return ja_auto_format_toast_success(inputs)
	if (locale === "hi") return hi_auto_format_toast_success(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_toast_success(inputs)
	return en_auto_format_toast_success(inputs)
});